import type { MetaFunction } from 'react-router'
// import CTASection from '#app/components/Landing-page/CTASection'
// import DifferenceSection from '#app/components/Landing-page/difference-section'
// import FaqSection from '#app/components/Landing-page/faq-section'
import FooterSection from '#app/components/Landing-page/footer-section'
import HeroSection from '#app/components/Landing-page/hero-section'
// import LeasingTeamMemberSection from '#app/components/Landing-page/leasing-team-member'
// import LogoMarqueeSection from '#app/components/Landing-page/logo-marquee-section'
// import PlatformSection from '#app/components/Landing-page/platform-section'
// import PricingSection from '#app/components/Landing-page/pricing-section'
// import ResultsStatsSection from '#app/components/Landing-page/real-stats-section'
// import HowItWorks from '#app/components/elements/howitwork/'
// import WhyTrueTenant from '#app/components/elements/whyTrueTenant/'
import { assets } from '#app/data/assets'
import { content } from '#app/data/content'
// import {
// 	landlordFeatures,
// 	landlordSteps,
// } from '#app/data/marketing/landlord-data'
// import { landloardFAQItems } from '#app/data/marketing/tenant-data'

export const meta: MetaFunction = () => {
	const title =
		"Landlord's leasing partner for tenant background & credit checks in Canada"
	const description =
		'Verify tenant background and credit with TrueTenant, the leasing partner built to help landlords in Canada with tenant screening.'

	return [
		{ title },
		{ name: 'description', content: description },
		{ property: 'og:title', content: title },
		{ property: 'og:description', content: description },
		{ property: 'og:type', content: 'website' },
		{ name: 'twitter:card', content: 'summary_large_image' },
		{ name: 'twitter:title', content: title },
		{ name: 'twitter:description', content: description },
	]
}

export default function LandlordRoute() {
	// const faqItems = landloardFAQItems
	// const steps = landlordSteps
	// const items = landlordFeatures

	return (
		<div>
			<HeroSection
				title={content.marketing.landlord.hero.title}
				buttonText={content.marketing.landlord.hero.buttonText}
				backgroundImage={assets.hero.landlord}
			/>
			{/* <LogoMarqueeSection />
			<PlatformSection />
			<HowItWorks
				steps={steps}
				title={content.marketing.landlord.sections.howItWorks.title}
				subTitle="Streamline your tenant screening process with our comprehensive platform"
			/>
			<WhyTrueTenant
				items={items}
				title={content.marketing.landlord.sections.whyTrueTenant.title}
				subTitle="Built for Canadian landlords who demand security, compliance, and peace of mind"
			/>
			<LeasingTeamMemberSection />
			<DifferenceSection />
			<ResultsStatsSection />
			<PricingSection />
			<FaqSection items={faqItems} />
			<CTASection /> */}
			<FooterSection />
		</div>
	)
}
